import { Controller } from "@hotwired/stimulus"

import TomSelect from 'tom-select'

// https://tom-select.js.org/docs/
export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ['remove_button'],
      maxOptions: 200,
    })
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
    }
  }
}
